import { Loading03Icon } from "@hugeicons-pro/core-stroke-rounded";
import { HugeiconsIcon } from "@hugeicons/react";
import { FC, ReactNode } from "react";
import { cx } from "shared/utils";

export const ProgressReportView: FC<{
  message?: string;
  children?: ReactNode;
  className?: string;
  heading?: string;
  size?: "sm" | "md";
}> = ({ message, children, className, heading, size = "md" }) => {
  return (
    <div className="flex h-full w-full items-center justify-center">
      <div
        className={cx(
          "flex max-w-md flex-col items-center justify-center p-6",
          className
        )}
      >
        <div
          className={cx(
            "flex items-center justify-center rounded-full bg-warning-50 mb-6",
            size === "md" ? "size-[100px]" : "size-16"
          )}
        >
          <HugeiconsIcon
            className="text-warning-600"
            size={size === "md" ? 40 : 24}
            strokeWidth={1.5}
            icon={Loading03Icon}
          />
        </div>

        {heading ? (
          <h1 className="mb-2 font-bold text-sm text-content-500">{heading}</h1>
        ) : null}

        {children ? (
          <div>{children}</div>
        ) : (
          <p className="text-center text-sm font-medium text-content-300">
            {message || "Report in progress. Please wait"}
          </p>
        )}
      </div>
    </div>
  );
};
